/*
 * Hydration-safe "am I rendering server markup right now?" signal.
 *
 * Every public route ships as real HTML (seo/ssr.js renders the React tree in Node at build time)
 * and the browser hydrates it. Hydration only works when the client's FIRST render produces exactly
 * the markup the server did, so anything that normally reads a browser-only value during render
 * (IntersectionObserver support, matchMedia, viewport width) must use the server value on that
 * first pass and switch afterwards.
 *
 * useSyncExternalStore gives us that for free: React uses `getServerSnapshot` for the server render
 * AND for the hydration render, then re-renders with `getSnapshot` before the browser paints if the
 * two differ. Client-side navigations (no server markup) go straight to `getSnapshot`.
 *
 *   const hydrating = useIsHydrating();   // true on the server + during hydration, false afterwards
 */
import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const getSnapshot = () => false;
const getServerSnapshot = () => true;

export const useIsHydrating = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

/** True when the document arrived with full pre-rendered markup in #root (set by index.js before hydration). */
export const isPrerenderedDocument = () =>
  typeof document !== 'undefined' && !!document.getElementById('root')?.hasAttribute('data-prerender');
